import * as React from 'react';
import { Backdrop, Modal, Fade, Box } from '@mui/material';
import { StyledListItemText, TextWrapper, WhiteButton, SvgStyle, CloseButton, PopupStyle } from './styles';
import SvgPlaceholder from '../SvgPlaceholder';
import { connect } from 'react-redux';
import { popupActiveSet } from 'store/general';
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';
import { activeStepSet } from 'store/steps';
import { creturesIcons, IconClose } from 'assets/icons';


const MainPopup = ({ responseError, svg, svgMsg, popupActiveSet, goToStep, innerStyle, container, children, closePopup, popupState, activeStepSet, ...props }) => {
  const { t } = useOnlineBookingLocale();
  const {
    open = popupState.open,
    message = popupState.message,
    button = popupState.button,
    callback = popupState.callback,
    goToStepOnClose = popupState.goToStepOnClose,
    icon = popupState.icon
  } = props || {};

  const handleClose = () => {
    popupActiveSet({ open: false, button: false })
    !!closePopup && closePopup()
    !!callback && callback();
    !!goToStepOnClose && activeStepSet(goToStepOnClose);
  }

  return (
    <>
      <Modal
        style={{ backdropFilter: 'blur(2px)' }}
        container={() => document.querySelector(`.${container ? container : 'BaseWrapper'}`)}
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500, style: { backgroundColor: 'var(--mui-palette-primary-main)' } } }}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >

        <Fade in={open} timeout={500}>
          <PopupStyle sx={{ ...innerStyle }}>
            {closePopup &&
              <CloseButton onClick={() => closePopup()} aria-label={t('common.back')} >
                <IconClose />
              </CloseButton>
            }

            {(svg || svgMsg || icon) &&
              <SvgStyle>
                <SvgPlaceholder svg={svg} icon={creturesIcons[icon]} msg={svgMsg} />
              </SvgStyle>
            }
              <TextWrapper>
              {message &&
                <StyledListItemText secondary={message} />}
              {button &&
                <WhiteButton size='small' onClick={handleClose}>
                  <span>{button}</span>
                </WhiteButton>}

            </TextWrapper>
            {children}
          </PopupStyle>
        </Fade>
      </Modal>
    </>
  );
}

export default connect(
  ({ current: { general: { popupState } } }) => ({ popupState }),
  { popupActiveSet, activeStepSet })
  (MainPopup);